import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { H1 } from 'components/common/Text/Text'
import Mixin from 'components/common/Mixin'
import { injectProps } from 'helpers/utils'
import { VEHICLE_SELECTOR_TARGET_ID, LOCATION_SELECTOR_TARGET_ID } from 'constant'
import Section from '../../QuickAppointmentPage/Section'

const BOTShoppingCartQuote = ({
  placeholders: {
    leftContent = [],
    rightContent = []
  } = {},
  handleTAOSDateTimeUpdate
}) =>
  <Fragment>
    <Title data-shopping-cart-quote-title headline noMargin>Shopping Cart Quote</Title>
    <Section noHeading>
      { injectProps(leftContent, { targetId: VEHICLE_SELECTOR_TARGET_ID }) }
      { injectProps(rightContent, { targetId: LOCATION_SELECTOR_TARGET_ID, handleTAOSDateTimeUpdate }) }
    </Section>
  </Fragment>

BOTShoppingCartQuote.propTypes = {
  handleTAOSDateTimeUpdate: PropTypes.func,
  placeholders: PropTypes.shape({
    leftContent: PropTypes.array,
    rightContent: PropTypes.array
  })
}

export default BOTShoppingCartQuote

const Title = styled(H1)`
  ${Mixin.responsive('padding', '0', '0 16px')}

  @media print {
    margin-left: -15px;
    margin-top: 30px;
  }
`
